import React, {
  createContext, useCallback, useContext, useEffect
} from 'react';
import { useParams } from 'react-router-dom';

import { AuthUserContext } from '../components';
import { useIndex, useShow } from '../hooks';

export const IdentityContext = createContext(null);

export function IdentityProvider({ children }) {
  const { personId } = useParams<{ personId: string }>();
  const self = personId === 'self';
  
  console.log('Person provider', personId, self);
  
  if (!self) {
    return (
      <PersonIdentityProvider>
        {children}
      </PersonIdentityProvider>
    );
  }
  
  return (
    <UserIdentityProvider>
      {children}
    </UserIdentityProvider>
  );
}

export function UserIdentityProvider({ children }) {
  const { user } = useContext(AuthUserContext);
  const { data, update, loading } = useIndex('people', { linked_user_id: user?.id });
  console.log('UserPersonProvider', user, data);

  const person = data?.[0];

  if (loading) {
    return <div>Loading person...</div>;
  }

  return (
    <IdentityContext.Provider value={{ person, update }}>
      {children}
    </IdentityContext.Provider>
  );
}

export function PersonIdentityProvider({ children }) {
  const { personId } = useParams<{ personId: string }>();
  const { handleShow, entity: person, loading } = useShow('people');

  useEffect(() => {
    handleShow(personId);
  }, [ handleShow, personId ]);

  const update = useCallback(async () => {
    await handleShow(personId);
  }, [ handleShow, personId ]);

  if (loading) {
    return <div>Loading person...</div>;
  }

  return (
    <IdentityContext.Provider value={{ person, update }}>
      {children}
    </IdentityContext.Provider>
  );
}
